import { Controller } from "@hotwired/stimulus"

// Display: cuenta hasta starts_at (hora real de inicio, igual que el front React).
// Auto-reload: cuando el reloj cruza entry_at (starts_at - MINUTES_BEFORE_ENTRY),
// recargamos la pagina para que el servidor vuelva a evaluar show_countdown? y
// entregue el contenido real.
export default class extends Controller {
  static targets = ["days", "hours", "minutes"]
  static values = { startsAt: String, entryAt: String }

  connect() {
    this.tick()
    this.intervalId = setInterval(() => this.tick(), 1000)
  }

  disconnect() {
    if (this.intervalId) clearInterval(this.intervalId)
  }

  tick() {
    const startsAt = Date.parse(this.startsAtValue)
    const entryAt = Date.parse(this.entryAtValue)
    if (Number.isNaN(startsAt)) return

    const now = Date.now()

    if (!Number.isNaN(entryAt) && now >= entryAt) {
      if (this.intervalId) clearInterval(this.intervalId)
      window.location.reload()
      return
    }

    const diffMs = Math.max(startsAt - now, 0)
    const totalSeconds = Math.floor(diffMs / 1000)
    const days = Math.floor(totalSeconds / 86400)
    const hours = Math.floor((totalSeconds % 86400) / 3600)
    const minutes = Math.floor((totalSeconds % 3600) / 60)

    if (this.hasDaysTarget) this.daysTarget.textContent = days
    if (this.hasHoursTarget) this.hoursTarget.textContent = hours
    if (this.hasMinutesTarget) this.minutesTarget.textContent = minutes
  }
}
